export const currencyFieldName = ['AmountDue'];
export const dateFieldName = ['DueDate'];
